/// <amd-module name="SearchUI/Constants" />

export namespace RepoConstants {
    export const PathSeparator = "/";
}

export namespace PathConstants {
    export const Ampersand = "&";
    export const Colon = ":";
    export const Equal = "=";
    export const Hash = "#";
    export const Hyphen = "-";
    export const Lessthan = "<";
    export const Percent = "%";
    export const Pipe = "|";
    export const QuestionMark = "?";
    export const Quote = "\"";
    export const Slash = "/";
    export const Star = "*";
    export const Tilde = "~";
    export const Underscore = "_";
    export const WhiteSpace = " ";
}

// These are duplicated from Wiki/Scripts/CommonConstants. Verify in both the places, when modified.
export var WikiGitIllegalSpecialChars = [":", "?", "*", "<", ">", "-", "|", "\""];
export var WikiGitIllegalSpecialCharEcapes = [/%3A/g, /%3F/g, /%2A/g, /%3C/g, /%3E/g, /%2D/g, /%7C/g, /%22/g];

export namespace FormatConstants {
    export const MDFormat = ".md";
}

export const WikiControllerName = "wiki";
export const WikiResourceName = "wikis";

export namespace WikiUrlParameters {
    export const PagePath = "pagePath";
    export const WikiVersion = "wikiVersion";

}
